import React from 'react';
import { BugIcon } from './Icons';
import styles from '../styles/FeedbackButton.module.css';

/**
 * Floating Feedback Button Component
 * Displays a fixed bottom-left button for quick access to feedback
 *
 * Props:
 * - onClick: Callback when button is clicked
 */
function FeedbackButton({ onClick }) {
  return (
    <button
      className={styles.feedbackButton}
      onClick={onClick}
      aria-label="Send feedback or report a bug"
      title="Send Feedback"
      data-tour="feedback-button"
    >
      <BugIcon size={24} />
    </button>
  );
}

export default FeedbackButton;
